import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ERIconComponent } from './inline-icons/icon.component';


@NgModule({
    declarations: [
        ERIconComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ERIconComponent
    ]
})
export class UiModule {}
